import React from 'react';
import { observer } from 'mobx-react';
import { JobApplicationCard } from './JobApplicationCard';
import { ApplicantHistoryTimeline } from './ApplicantHistoryTimeline';
import EmptyState from 'ats/components/empty-state/EmptyState';
import { EMPTY_STATE_ICONS } from 'ats/components/empty-state/emptyStateIcons';
import { modalStore } from 'components/layout/modals/ModalStore';
import { AddJobModal } from '../../pipeline/components/AddJobModal';

@observer
export class ApplicantHistory extends React.Component {
	handleAssignToJob = () => {
		modalStore.openModal(
			{ title: 'Assign to an Open Job', size: 'xl', position: 'center' },
			<AddJobModal
				applicantId={this.props.applicant?.id}
				handleSuccess={this.props.onSuccess}
			/>
		);
	};

	renderJobApplications() {
		if (!this.props.groupByPosition) {
			return (
				<ApplicantHistoryTimeline
					applicant={this.props.applicant}
					onSuccess={this.props.onSuccess}
				/>
			);
		}

		return (
			<div className="applicant-history-list">
				{this.props.applicant.jobApplications.map(item => (
					<JobApplicationCard
						applicant={this.props.applicant}
						jobApplication={item}
						key={item.id}
						onSuccess={this.props.onSuccess}
						initialExpanded={item.id === this.props.expandedJobApplicationId}
					/>
				))}
			</div>
		);
	}

	render() {
		const hasJobApplications =
			this.props.applicant?.jobApplications?.length > 0;

		return (
			<div className="applicant-history">
				{hasJobApplications ? (
					this.renderJobApplications()
				) : (
					<div className="applicant-profile-tab-empty applicant-profile-tab-empty--history">
						<EmptyState
							icon={EMPTY_STATE_ICONS.jobHistoryEmpty}
							iconAlt="No job applications"
							message="No job assignments or applications found for this candidate."
							actionsInText
							actionText="Assign to a Job"
							onActionClick={this.handleAssignToJob}
						/>
					</div>
				)}
			</div>
		);
	}
}
